/* ==========================================================================
   Palmora — JS nhóm sections-a.
   1) Video tắt tiếng (Video tính năng + Băng video): chỉ tự chạy khi đang nằm trong màn hình
      (IntersectionObserver), nút / chạm vào video để tạm dừng hoặc phát. Người dùng đã tạm dừng thì
      không tự chạy lại. prefers-reduced-motion: không tự chạy.
   2) Băng video chạy vô tận (pm-video-carousel): nhân bản thẻ (aria-hidden) vừa đủ phủ khung,
      chạy bằng Web Animations; dừng khi rê chuột / focus / section ra khỏi màn hình / tab ẩn.
      prefers-reduced-motion hoặc trình duyệt không hỗ trợ: giữ khung cuộn ngang (CSS mặc định).
   3) Carousel đánh giá (pm-reviews): nút mũi tên trước/sau, tự ẩn nút khi không cuộn được.
   4) FAQ (pm-faq): tuỳ chọn chỉ mở một câu; Theme editor chọn block thì mở câu đó.
   File được chèn bởi nhiều section (mỗi section một thẻ script) nên chỉ khởi tạo một lần;
   các lần sau chỉ quét lại DOM. Mọi root đã khởi tạo được đánh dấu để không gắn sự kiện lặp.
   ========================================================================== */
(function () {
  'use strict';

  if (window.PalmoraSectionsA && typeof window.PalmoraSectionsA.init === 'function') {
    window.PalmoraSectionsA.init(document);
    return;
  }

  var reduceMotion = false;
  try {
    reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (e) {
    reduceMotion = false;
  }

  var hasIO = 'IntersectionObserver' in window;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  /* ------------------------------------------------------------------
     1) VIDEO TẮT TIẾNG + NÚT PHÁT/TẠM DỪNG
     ------------------------------------------------------------------ */
  function syncVideoState(wrapper, video) {
    var playing = !video.paused && !video.ended;
    wrapper.classList.toggle('is-playing', playing);
    var btn = wrapper.querySelector('[data-pm-video-toggle]');
    if (btn) {
      var label = playing ? btn.getAttribute('data-label-pause') : btn.getAttribute('data-label-play');
      if (label) btn.setAttribute('aria-label', label);
    }
  }

  function playVideo(video) {
    video.muted = true;
    var p;
    try {
      p = video.play();
    } catch (e) {
      p = null;
    }
    /* Trình duyệt chặn tự phát (ví dụ chế độ tiết kiệm pin iOS): giữ poster, nút về trạng thái "Phát" */
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function canAutoplay(video) {
    return !reduceMotion &&
      video.hasAttribute('data-pm-autoplay') &&
      video.getAttribute('data-pm-user-paused') !== '1';
  }

  var videoObserver = null;
  if (hasIO) {
    videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        /* isIntersecting vẫn true khi chỉ lộ 1px, nên so tỉ lệ hiển thị */
        if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
          if (canAutoplay(video) && video.paused) playVideo(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { threshold: [0, 0.3, 0.6] });
  }

  /* Gắn sự kiện đồng bộ trạng thái nút cho một khung video (chạy một lần cho mỗi khung) */
  function bindVideo(wrapper) {
    if (!wrapper || wrapper.__pmVideoReady) return null;
    var video = wrapper.querySelector('video');
    if (!video) return null;
    wrapper.__pmVideoReady = true;
    wrapper.classList.add('is-video-ready');

    video.muted = true;
    var sync = function () { syncVideoState(wrapper, video); };
    video.addEventListener('play', sync);
    video.addEventListener('playing', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('ended', sync);
    sync();
    return video;
  }

  /* Tự phát khi vào màn hình, tự dừng khi ra (IntersectionObserver; không có IO thì phát luôn) */
  function observeVideo(video) {
    if (!video || reduceMotion || !video.hasAttribute('data-pm-autoplay')) return;
    if (videoObserver) {
      videoObserver.observe(video);
    } else if (canAutoplay(video)) {
      playVideo(video);
    }
  }

  function unbindVideos(scope) {
    if (!videoObserver || !scope) return;
    toArray(scope.querySelectorAll('video')).forEach(function (video) {
      videoObserver.unobserve(video);
    });
  }

  function toggleVideo(wrapper) {
    var video = wrapper && wrapper.querySelector('video');
    if (!video) return;
    if (video.paused || video.ended) {
      video.removeAttribute('data-pm-user-paused');
      playVideo(video);
    } else {
      video.setAttribute('data-pm-user-paused', '1');
      video.pause();
    }
  }

  /* Bấm nút hoặc chạm vào video (chỉ trong section của nhóm này) */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var root = target.closest('[data-pm-section="features-video"], [data-pm-section="video-carousel"]');
    if (!root) return;
    var btn = target.closest('[data-pm-video-toggle]');
    var onVideo = !btn && target.tagName === 'VIDEO';
    if (!btn && !onVideo) return;
    var wrapper = target.closest('[data-pm-video]');
    if (!wrapper) return;
    event.preventDefault();
    toggleVideo(wrapper);
  });

  /* ------------------------------------------------------------------
     2) BĂNG VIDEO CHẠY VÔ TẬN
     Khi băng chạy, thẻ di chuyển bằng transform nên không dựa vào IntersectionObserver để
     bật/tắt video (có trình duyệt không tính lại giao cắt cho animation chạy trên compositor):
     cứ ~400ms đo vị trí thẻ so với khung, thẻ hiện >= 35% thì phát, còn lại thì dừng.
     Khi băng đứng yên (giảm chuyển động / không hỗ trợ animate) thì dùng IntersectionObserver như thường.
     ------------------------------------------------------------------ */
  var marquees = [];

  function VideoMarquee(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-pm-vc-viewport]');
    this.track = root.querySelector('[data-pm-vc-track]');
    this.speed = parseFloat(root.getAttribute('data-pm-speed')) || 30;
    this.anim = null;
    this.timer = null;
    this.distance = 0;
    this.duration = 0;
    this.hover = false;
    this.focus = false;
    this.inView = true;
    this.hold = false;
    this.lastWidth = 0;
    this.observer = null;
    if (!this.viewport || !this.track) return;
    this.bind();
    this.build();
  }

  VideoMarquee.prototype.originals = function () {
    return toArray(this.track.querySelectorAll('[data-pm-vc-card]:not(.is-clone)'));
  };

  VideoMarquee.prototype.teardown = function () {
    if (!this.track) return;
    if (this.anim) {
      try { this.anim.cancel(); } catch (e) { /* bỏ qua */ }
      this.anim = null;
    }
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    toArray(this.track.querySelectorAll('.is-clone')).forEach(function (clone) {
      unbindVideos(clone);
      clone.parentNode.removeChild(clone);
    });
    unbindVideos(this.track);
    this.root.classList.remove('is-marquee');
  };

  VideoMarquee.prototype.makeClone = function (card) {
    var clone = card.cloneNode(true);
    clone.classList.add('is-clone');
    clone.classList.remove('is-playing');
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-shopify-editor-block');
    clone.removeAttribute('id');
    toArray(clone.querySelectorAll('button, a, [tabindex]')).forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
    toArray(clone.querySelectorAll('video')).forEach(function (video) {
      video.removeAttribute('data-pm-user-paused');
    });
    return clone;
  };

  /* Băng đứng yên: video gốc tự phát/dừng theo IntersectionObserver */
  VideoMarquee.prototype.observeOriginals = function () {
    this.originals().forEach(function (card) {
      observeVideo(card.querySelector('video'));
    });
  };

  VideoMarquee.prototype.build = function () {
    this.teardown();
    this.lastWidth = this.viewport.clientWidth;

    var cards = this.originals();
    if (!cards.length) return;
    if (reduceMotion || typeof this.track.animate !== 'function') {
      this.observeOriginals();
      return;
    }

    var first = cards[0];
    var last = cards[cards.length - 1];
    var gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
    var setWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft + gap;
    if (setWidth <= 0) {
      this.observeOriginals();
      return;
    }

    /* Đủ bản sao để chiều dài băng >= một lượt + chiều rộng khung (không bao giờ lộ khoảng trống) */
    var copies = Math.max(1, Math.ceil(this.viewport.clientWidth / setWidth));
    var fragment = document.createDocumentFragment();
    var clones = [];
    for (var c = 0; c < copies; c++) {
      for (var i = 0; i < cards.length; i++) {
        var clone = this.makeClone(cards[i]);
        clones.push(clone);
        fragment.appendChild(clone);
      }
    }
    this.track.appendChild(fragment);
    this.root.classList.add('is-marquee');

    /* Khoảng dịch chính xác = vị trí bản sao đầu tiên so với thẻ gốc đầu tiên */
    this.distance = clones[0].offsetLeft - first.offsetLeft;
    if (this.distance <= 0) {
      this.teardown();
      this.observeOriginals();
      return;
    }
    clones.forEach(function (clone) {
      clone.__pmVideoReady = false;
      bindVideo(clone);
    });

    this.duration = (this.distance / this.speed) * 1000;
    this.anim = this.track.animate(
      [
        { transform: 'translate3d(0, 0, 0)' },
        { transform: 'translate3d(' + (-this.distance) + 'px, 0, 0)' }
      ],
      { duration: this.duration, iterations: Infinity, easing: 'linear' }
    );

    var self = this;
    this.timer = setInterval(function () { self.checkVideos(); }, 400);
    this.update();
    this.checkVideos();
  };

  /* Phát video của thẻ đang hiện trong khung, dừng thẻ đã ra khỏi khung */
  VideoMarquee.prototype.checkVideos = function () {
    var active = this.inView && !document.hidden;
    var box = this.viewport.getBoundingClientRect();
    toArray(this.track.querySelectorAll('[data-pm-vc-card]')).forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      var visible = false;
      if (active) {
        var r = card.getBoundingClientRect();
        var overlap = Math.min(r.right, box.right) - Math.max(r.left, box.left);
        visible = r.width > 0 && overlap / r.width >= 0.35 && r.bottom > 0 && r.top < window.innerHeight;
      }
      if (visible) {
        if (video.paused && canAutoplay(video)) playVideo(video);
      } else if (!video.paused) {
        video.pause();
      }
    });
  };

  VideoMarquee.prototype.update = function () {
    if (!this.anim) return;
    var paused = this.hover || this.focus || this.hold || !this.inView || document.hidden;
    try {
      if (paused && this.anim.playState === 'running') this.anim.pause();
      if (!paused && this.anim.playState !== 'running') this.anim.play();
    } catch (e) { /* bỏ qua */ }
  };

  VideoMarquee.prototype.bind = function () {
    var self = this;
    var vp = this.viewport;

    vp.addEventListener('mouseenter', function () { self.hover = true; self.update(); });
    vp.addEventListener('mouseleave', function () { self.hover = false; self.update(); });
    vp.addEventListener('focusin', function () { self.focus = true; self.update(); });
    vp.addEventListener('focusout', function (event) {
      if (event.relatedTarget && vp.contains(event.relatedTarget)) return;
      self.focus = false;
      self.update();
    });

    if (hasIO) {
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          self.inView = entry.isIntersecting;
          self.update();
          if (self.anim) self.checkVideos();
        });
      });
      this.observer.observe(this.root);
    }
  };

  /* Theme editor: chọn block ⇒ dừng băng và đưa thẻ đó về đầu khung */
  VideoMarquee.prototype.showCard = function (card) {
    var cards = this.originals();
    var index = cards.indexOf(card);
    if (index < 0) return;
    this.hold = true;
    if (this.anim && this.distance > 0) {
      this.update();
      var offset = card.offsetLeft - cards[0].offsetLeft;
      try { this.anim.currentTime = (offset / this.distance) * this.duration; } catch (e) { /* bỏ qua */ }
    } else {
      this.viewport.scrollLeft = Math.max(0, card.offsetLeft - (parseFloat(window.getComputedStyle(this.viewport).scrollPaddingLeft) || 0));
    }
  };

  VideoMarquee.prototype.release = function () {
    this.hold = false;
    this.update();
  };

  VideoMarquee.prototype.destroy = function () {
    this.teardown();
    if (this.observer) this.observer.disconnect();
    unbindVideos(this.root);
  };

  /* ------------------------------------------------------------------
     3) CAROUSEL ĐÁNH GIÁ
     ------------------------------------------------------------------ */
  var reviewCarousels = [];

  function Reviews(root) {
    this.root = root;
    this.track = root.querySelector('[data-pm-reviews-track]');
    this.prev = root.querySelector('[data-pm-reviews-prev]');
    this.next = root.querySelector('[data-pm-reviews-next]');
    this.ticking = false;
    if (!this.track) return;
    this.bind();
    root.classList.add('is-ready');
    this.update();
  }

  Reviews.prototype.step = function () {
    var card = this.track.querySelector('[data-pm-reviews-card]');
    if (!card) return this.track.clientWidth;
    var gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
    var one = card.offsetWidth + gap;
    var perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / one));
    return one * perView;
  };

  Reviews.prototype.scrollToX = function (x) {
    var max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    x = Math.max(0, Math.min(max, x));
    try {
      this.track.scrollTo({ left: x, behavior: reduceMotion ? 'auto' : 'smooth' });
    } catch (e) {
      this.track.scrollLeft = x;
    }
  };

  Reviews.prototype.go = function (dir) {
    this.scrollToX(this.track.scrollLeft + dir * this.step());
  };

  Reviews.prototype.update = function () {
    var max = this.track.scrollWidth - this.track.clientWidth;
    var cur = this.track.scrollLeft;
    var scrollable = max > 2;
    this.root.classList.toggle('is-static', !scrollable);
    if (this.prev) this.prev.disabled = !scrollable || cur <= 2;
    if (this.next) this.next.disabled = !scrollable || cur >= max - 2;
  };

  Reviews.prototype.requestUpdate = function () {
    var self = this;
    if (self.ticking) return;
    self.ticking = true;
    var raf = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
    raf(function () {
      self.ticking = false;
      self.update();
    });
  };

  Reviews.prototype.bind = function () {
    var self = this;
    if (this.prev) this.prev.addEventListener('click', function () { self.go(-1); });
    if (this.next) this.next.addEventListener('click', function () { self.go(1); });
    this.track.addEventListener('scroll', function () { self.requestUpdate(); }, { passive: true });
  };

  Reviews.prototype.showCard = function (card) {
    if (!this.track.contains(card)) return;
    var pad = parseFloat(window.getComputedStyle(this.track).scrollPaddingLeft) || 0;
    this.scrollToX(card.offsetLeft - pad);
  };

  /* ------------------------------------------------------------------
     4) FAQ — sự kiện "toggle" của <details> không nổi bọt nên nghe ở pha capture
     ------------------------------------------------------------------ */
  document.addEventListener('toggle', function (event) {
    var item = event.target;
    if (!item || !item.matches || !item.matches('[data-pm-section="faq"] details[data-pm-faq-item]') || !item.open) return;
    var list = item.closest('[data-pm-faq-list]');
    if (!list || list.getAttribute('data-pm-faq-list') !== 'single') return;
    toArray(list.querySelectorAll('details[data-pm-faq-item][open]')).forEach(function (other) {
      if (other !== item) other.open = false;
    });
  }, true);

  /* ------------------------------------------------------------------
     KHỞI TẠO + SỰ KIỆN THEME EDITOR
     ------------------------------------------------------------------ */
  function prune() {
    marquees = marquees.filter(function (m) { return document.documentElement.contains(m.root); });
    reviewCarousels = reviewCarousels.filter(function (r) { return document.documentElement.contains(r.root); });
  }

  function init(scope) {
    scope = scope || document;

    try {
      toArray(scope.querySelectorAll('[data-pm-section="features-video"] [data-pm-video]')).forEach(function (wrapper) {
        observeVideo(bindVideo(wrapper));
      });
    } catch (e) { /* không để lỗi lan ra trang */ }

    try {
      toArray(scope.querySelectorAll('[data-pm-section="video-carousel"]')).forEach(function (root) {
        if (root.__pmMarquee) return;
        toArray(root.querySelectorAll('[data-pm-video]')).forEach(bindVideo);
        /* Section không còn thẻ nào (không in khung/băng) thì không dựng băng chạy */
        if (!root.querySelector('[data-pm-vc-viewport]') || !root.querySelector('[data-pm-vc-track]')) return;
        root.__pmMarquee = new VideoMarquee(root);
        marquees.push(root.__pmMarquee);
      });
    } catch (e) { /* như trên */ }

    try {
      toArray(scope.querySelectorAll('[data-pm-section="reviews"]')).forEach(function (root) {
        if (root.__pmReviews) return;
        root.__pmReviews = new Reviews(root);
        reviewCarousels.push(root.__pmReviews);
      });
    } catch (e) { /* như trên */ }
  }

  window.PalmoraSectionsA = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Băng video phụ thuộc chiều rộng khung: dựng lại khi chiều rộng đổi (bỏ qua đổi chiều cao do thanh địa chỉ mobile) */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      prune();
      marquees.forEach(function (m) {
        if (m.viewport && m.viewport.clientWidth !== m.lastWidth) m.build();
      });
      reviewCarousels.forEach(function (r) { r.update(); });
    }, 200);
  });

  document.addEventListener('visibilitychange', function () {
    marquees.forEach(function (m) {
      m.update();
      if (m.anim) m.checkVideos();
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event.target;
    if (!scope) return;
    marquees.forEach(function (m) {
      if (scope.contains(m.root)) m.destroy();
    });
    unbindVideos(scope);
    setTimeout(prune, 0);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    if (!el || !el.matches) return;

    if (el.matches('[data-pm-section="faq"] details[data-pm-faq-item]')) {
      el.open = true;
      return;
    }

    if (el.matches('[data-pm-vc-card]')) {
      marquees.forEach(function (m) {
        if (m.root.contains(el)) m.showCard(el);
      });
      return;
    }

    if (el.matches('[data-pm-reviews-card]')) {
      reviewCarousels.forEach(function (r) {
        if (r.root.contains(el)) r.showCard(el);
      });
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var el = event.target;
    if (!el || !el.matches || !el.matches('[data-pm-vc-card]')) return;
    marquees.forEach(function (m) {
      if (m.root.contains(el)) m.release();
    });
  });
})();
